// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root___AHG5","title":"AfterFrontImage_title__2ZoJl"};